import React, { useState } from 'react';
import { Linkedin, Instagram, Link2, Check, Share2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { cn } from '@/lib/utils';

// Lightweight social sharing. (AI content generation + direct posting to
// LinkedIn/Instagram is on the product backlog.)
export default function SocialShare({ title = '', summary = '', className }) {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href : 'https://billportal.io';

  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  const copyForInstagram = async () => {
    const text = `${title}\n\n${summary}\n\n${url}`;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch (e) {
      /* ignore */
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text: summary, url });
      } catch (e) {
        /* user cancelled */
      }
    } else {
      copyForInstagram();
    }
  };

  const btn = 'inline-flex h-9 items-center gap-2 rounded-full border border-slate-200 px-3.5 text-sm font-medium text-slate-600 transition-colors hover:border-brand hover:text-brand dark:border-white/15 dark:text-slate-300';

  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      <span className="mr-1 text-sm font-medium text-slate-500 dark:text-slate-400">{t('common.share')}</span>
      <a href={linkedin} target="_blank" rel="noreferrer" className={btn} aria-label="Share on LinkedIn">
        <Linkedin className="h-4 w-4" /> LinkedIn
      </a>
      <button type="button" onClick={copyForInstagram} className={btn} aria-label="Copy caption for Instagram">
        <Instagram className="h-4 w-4" /> Instagram
      </button>
      <button type="button" onClick={nativeShare} className={btn} aria-label="Share">
        <Share2 className="h-4 w-4" />
      </button>
      <button type="button" onClick={copyForInstagram} className={btn} aria-label="Copy link">
        {copied ? <Check className="h-4 w-4 text-brand" /> : <Link2 className="h-4 w-4" />}
        {copied ? 'Copied' : 'Copy'}
      </button>
    </div>
  );
}
